import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import LoadingImage from '../Images/loading.gif'; 
import ErrorPage from './Errorpage';

const ICTPortal = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const location = useLocation();
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
  
  useEffect(() => {
    try {
      window.history.pushState("you are being redirected...", "Redirect", "/redirect");
    } catch (err) {
      if (typeof console !== 'undefined') console.log(err);
    }
    
    // Dynamically extract all query parameters without altering case
    const queryParams = new URLSearchParams(location.search);
    const params = {};
    queryParams.forEach((value, key) => {
      params[key] = value; // Keep keys as they are
    });

    console.log('Extracted Query Parameters:', params); // Log the extracted parameters
    
    fetchICTSamlResponse(params);
  }, [location]);
  
  const fetchICTSamlResponse = async (params) => {
    try {
      console.log('Request parameters:', params);
      const response = await axios.get(`${API_URL}/api/ICTPortal/AccessManagement`, {
        params: {
          ...params
        }
      });

      if (response.data && response.data.targetUrl && response.data.samlResponse) {
        // For SAML responses, we need to use form submission as it requires POST method
        // with specific parameters that can't be handled with simple redirect
        submitSAMLForm(response.data.targetUrl, response.data.samlResponse);
      } else if (response.data && response.data.url) {
        // If a direct URL is provided, use window.location.href
        window.location.href = response.data.url;
      } else {
        setError('ict');
        setLoading(false);
      }
    } catch (error) {
      console.error('Error fetching ICT Portal SAML response:', error);
      setError('ict');
      setLoading(false);
    }
  };
  
  // SAML authentication requires form submission - this can't be replaced with window.location.href
  const submitSAMLForm = (targetUrl, samlResponse) => {
    const form = document.createElement('form');
    form.method = 'post';
    form.action = targetUrl;
    
    const samlInput = document.createElement('input');
    samlInput.type = 'hidden';
    samlInput.name = 'SAMLResponse';
    samlInput.value = samlResponse;
    
    form.appendChild(samlInput);
    document.body.appendChild(form);
    form.submit();
  };
  
  return (
    <div>
      <table style={{backgroundColor: 'transparent'}} cellPadding="0" cellSpacing="0">
        <tbody>
          <tr>
            <td style={{width: '50%'}}></td>
            <td align="center" style={{fontSize: 'x-large'}}>
              {loading && (
                <>
                  <img id="loadinggif" src={LoadingImage} alt="Loading" />
                  <div id="loadingtext">Loading...</div>
                </>
              )}
              {error && <ErrorPage errorType="ict" />}
            </td>
            <td style={{width: '50%'}}></td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default ICTPortal;